module.exports = __webpack_public_path__ + "img/banner.a8de8935.jpg";